import { memo } from "react";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { ThemedCloneIcon } from "assets/CXFIcons/Designer/ContextActions";
import { useTranslation } from "react-i18next";

const ButtonCloneNode = ({ cloneNode, allowEditWorkflow }) => {
  const { t } = useTranslation("flowDesigner");
  const { currentSavedFlow } = useSelector((state) => state.designer.flows);
  const isActiveFlow = currentSavedFlow?.shared_status === "active";

  return (
    <Tooltip title={t("buttons.clone_node")} placement="bottom-start">
      <IconButton
        size="small"
        style={{ width: "100%" }}
        onClick={cloneNode}
        disabled={isActiveFlow || !allowEditWorkflow}
      >
        <ThemedCloneIcon width="21px" height="21px" color="currentColor" />
      </IconButton>
    </Tooltip>
  );
};

export default memo(ButtonCloneNode);
